/** @format */

import React, { useState } from "react";
import { useParams } from "react-router-dom";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import "./index.scss";
import { formatDate, convertToCamelCaseFromUnderScore } from "../../../utils";
import {
  DATE_FORMATS,
  getAvatarColor,
  TICKET_STAGES,
} from "../../../utils/constants";
import { convertPartsToString } from "./helper";
import { Avatar, Box, Typography } from "@mui/material";
import { HTTP_METHODS, invokeApi } from "../../../utils/http-service";
import { HOSTNAME, REST_URLS } from "../../../utils/endpoints";
import { toast } from "react-toastify";
import { Icon } from "@iconify/react";
const TimeLineInfo = ({ ticketDetails, openForm, loadData, timeline }) => {
  const { id } = useParams();
  const [openModal, setOpenModal] = useState(null);
  const [message, setMessage] = useState("");

  const updateDateOfInspection = (payload) => {
    invokeApi(
      HTTP_METHODS.PUT,
      `${HOSTNAME}${REST_URLS.TICKETS}/${id}`,
      payload
    )
      .then((response) => {
        if (response?.message) {
          toast.error("Update Failed");
        } else {
          loadData();
        }
      })
      .catch((err) => console.error(err));
  };

  const getTimeLine = (timelineDetails, index) => {
    const { stage, stageDetails, updatedAt } = timelineDetails;

    let stageDetailsObj = {};
    try {
      stageDetailsObj = JSON.parse(stageDetails);
    } catch (err) {}

    switch (stage) {
      case TICKET_STAGES.COMPLAINT_FORM_SUBMITTED:
        return (
          <div key={index}>
            <Typography className="line1 primary-text">
              Created on{" "}
              {formatDate(ticketDetails?.createdAt, DATE_FORMATS["DD-MM-YYYY"])}{" "}
            </Typography>
            <Typography className="line2">
              by {ticketDetails?.createdBy}
            </Typography>
          </div>
        );
      case TICKET_STAGES.ASSIGN_SE:
        return (
          <div key={index}>
            <Typography className="line1 primary-text">
              Service Engineer Assigned
            </Typography>
            <Typography className="line2">
              {stageDetailsObj.name || "-"}
            </Typography>
            <Typography className="line2">
              Updated on - {formatDate(updatedAt, DATE_FORMATS["DD-MM-YYYY"])}
            </Typography>
          </div>
        );
      case TICKET_STAGES.UPDATE_DEFECT_CODE:
        return (
          <div key={index}>
            <Typography className="line1 primary-text">
              Defect code updated
            </Typography>
            <div className="line2">
              {(stageDetailsObj.defectCode &&
                `${stageDetailsObj.defectCode.code} - ${stageDetailsObj.defectCode.description}`) ||
                "-"}
            </div>
            <Typography className="line2">
              Updated on - {formatDate(updatedAt, DATE_FORMATS["DD-MM-YYYY"])}
            </Typography>
          </div>
        );
      case TICKET_STAGES.UPDATE_ACTION_CODE:
        return (
          <div key={index}>
            <Typography className="line1 primary-text">
              Action code updated
            </Typography>
            <div className="line2">
              {(stageDetailsObj.actionCode &&
                `${stageDetailsObj.actionCode.code} - ${stageDetailsObj.actionCode.description}`) ||
                "-"}
            </div>
            <Typography className="line2">
              Updated on - {formatDate(updatedAt, DATE_FORMATS["DD-MM-YYYY"])}
            </Typography>
          </div>
        );
      case TICKET_STAGES.ENGINE_REPLACEMENT:
        return (
          <div key={index} className="time-c-extra">
            <Typography className="line1 primary-text">
              Engine replacement details
            </Typography>
            <div className="line2">
              <Typography>
                {" "}
                {`Replacement By: ${stageDetailsObj.replacementBy}`}
              </Typography>
              <Typography>
                {`Engine Type: ${convertToCamelCaseFromUnderScore(
                  stageDetailsObj.engineType
                )}`}
              </Typography>
              <Typography>
                {`Engine Type Value: ${stageDetailsObj.engineTypeValue}`}
              </Typography>
              <Typography>
                {" "}
                {`Extra Text: ${stageDetailsObj.extraText}`}
              </Typography>
              <Typography className="line2">
                Updated on - {formatDate(updatedAt, DATE_FORMATS["DD-MM-YYYY"])}
              </Typography>
            </div>
          </div>
        );
      case "PART/S_REPLACEMENT":
        return (
          <div key={index} className="time-c-extra">
            <Typography className="line1 primary-text">
              Parts replacement details
            </Typography>
            <div className="line2">
              <Typography>
                {" "}
                {`Mode :${convertToCamelCaseFromUnderScore(
                  stageDetailsObj.mode
                )}`}
              </Typography>
              <Typography> {`Scope:${stageDetailsObj.scope}`}</Typography>
              <Typography>
                {`Parts : ${convertPartsToString(
                  stageDetailsObj.listOfParts || []
                )}`}
              </Typography>
              <Typography> {`Extra :${stageDetailsObj.extra}`}</Typography>
              <Typography className="line2">
                Updated on - {formatDate(updatedAt, DATE_FORMATS["DD-MM-YYYY"])}
              </Typography>
            </div>
          </div>
        );
      // case TICKET_STAGES.COMMENT:
      //   return (
      //     <div key={index}>
      //       <Typography className="line1">Comment</Typography>
      //       <Typography className="line2">
      //         {stageDetailsObj.comment || "-"}
      //       </Typography>
      //     </div>
      //   );
      case TICKET_STAGES.TICKET_UPDATED:

      case TICKET_STAGES.ENTER_ENGINE_DETAILS:
        const { reason = "", status = "" } = stageDetailsObj || {};
        if (reason.includes("Date of inspection")) {
          return (
            <div key={index}>
              <Typography className="line1 primary-text">
                {timelineDetails.description}
              </Typography>
              <Typography className="line2">
                Date of inspection confirmed on{" "}
                {formatDate(
                  ticketDetails.dateOfInspection,
                  DATE_FORMATS["DD-MM-YYYY"]
                )}
              </Typography>
            </div>
          );
        }
        return (
          <div key={index}>
            <Typography className="line1 primary-text">
              {timelineDetails.description || "Ticket Updated"}
            </Typography>
            <Typography className="line2">
              {stageDetailsObj.reason ? stageDetailsObj.reason : status || "-"}
            </Typography>
            {timelineDetails?.comment && (
              <Typography className="line2">
                Comment: {timelineDetails.comment}
              </Typography>
            )}
          </div>
        );
      case TICKET_STAGES.OUT_OF_WARRANTY:
        return (
          <div key={index}>
            <Typography className="line1 primary-text">
              {timelineDetails.description || "Ticket Updated"}
            </Typography>
            <Typography className="line2">
              {stageDetailsObj.extendedTechnicalSupport ? "Yes" : "No"}
            </Typography>
            <Typography className="line2">
              Updated on - {formatDate(updatedAt, DATE_FORMATS["DD-MM-YYYY"])}
            </Typography>
          </div>
        );
      // case TICKET_STAGES.ATTACHMENT:
      //   return (
      //     <div key={index}>
      //       <Typography className="line1">Attachment</Typography>
      //       <Typography className="line2">
      //         <a
      //           className="open-link"
      //           href={splitFileName(stageDetailsObj.url)}
      //           target="_blank"
      //         >
      //           Open attachment
      //         </a>
      //       </Typography>
      //     </div>
      //   );
      case TICKET_STAGES.JIR_CREATED:
        return (
          <div key={index}>
            <Typography className="line1 primary-text">
              {stageDetailsObj.reason || "JIR Created"}
            </Typography>
            <Typography className="line2">
              Updated on - {formatDate(updatedAt, DATE_FORMATS["DD-MM-YYYY"])}
            </Typography>
          </div>
        );
      case TICKET_STAGES.WAITING_FOR_SE_ACKNOWLEDGEMENT:
        return (
          <div key={index}>
            <Typography className="line1 primary-text">
              {stageDetailsObj?.reason ||
                "Waiting for Service Engineer Acknowledgement"}
            </Typography>
            <Typography className="line2">
              Updated on - {formatDate(updatedAt, DATE_FORMATS["DD-MM-YYYY"])}
            </Typography>
          </div>
        );
      case TICKET_STAGES.ADD_INSPECTION_DATE:
        return (
          <div key={index}>
            <Typography className="line1 primary-text">
              {stageDetailsObj?.reason ||
                "Ticket Acknowledged by Service Engineer"}
            </Typography>
            <Typography className="line2">
              Updated on - {formatDate(updatedAt, DATE_FORMATS["DD-MM-YYYY"])}
            </Typography>
          </div>
        );
      case TICKET_STAGES.FOC_CREATED:
        return (
          <div key={index}>
            <Typography className="line1 primary-text">
              {stageDetailsObj.reason || "FOC Created"}
            </Typography>
            <Typography className="line2">
              FOC Status - {stageDetailsObj.focStatus}
            </Typography>
            <Typography className="line2">
              Updated on - {formatDate(updatedAt, DATE_FORMATS["DD-MM-YYYY"])}
            </Typography>
          </div>
        );
      case TICKET_STAGES.FOC_UPDATED:
        return (
          <div key={index}>
            <Typography className="line1 primary-text">
              {stageDetailsObj.reason || "FOC Updated"}
            </Typography>
            <Typography className="line2">
              FOC Status - {stageDetailsObj.focStatus}
            </Typography>
            <Typography className="line2">
              Updated on - {formatDate(updatedAt, DATE_FORMATS["DD-MM-YYYY"])}
            </Typography>
          </div>
        );
      case TICKET_STAGES.APPROVER_ASSIGNED:
        return (
          <div key={index}>
            <Typography className="line1 primary-text">
              Approver Assigned
            </Typography>

            <Typography className="line2">
              Date- {formatDate(updatedAt, DATE_FORMATS["DD-MM-YYYY"])}
            </Typography>
          </div>
        );
      case TICKET_STAGES.ENGINE_REPLACEMENT_REJECTED:
        return (
          <div key={index}>
            <Typography className="line1 primary-text">
              Engine Replacement Rejected
            </Typography>

            <Typography className="line2">
              Updated on - {formatDate(updatedAt, DATE_FORMATS["DD-MM-YYYY"])}
            </Typography>
          </div>
        );
      case TICKET_STAGES.ENGINE_REPLACEMENT_APPROVED:
        return (
          <div key={index}>
            <Typography className="line1 primary-text">
              Engine Replacement Approved
            </Typography>

            <Typography className="line2">
              Updated on - {formatDate(updatedAt, DATE_FORMATS["DD-MM-YYYY"])}
            </Typography>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className="form-con" style={{ width: "96%" }}>
      <div className="time-line">
        <p className="form-header">Ticket Timeline</p>

        {timeline.map((timelineDetails, index) => {
          if (
            timelineDetails?.stage !== TICKET_STAGES.ATTACHMENT &&
            timelineDetails?.stage !== TICKET_STAGES.COMMENT
          ) {
            const name = timelineDetails?.createdBy?.name;
            return (
              <div key={index}>
                <div>
                  <div className="comment-con">
                    {name ? (
                      <Avatar
                        sx={{
                          bgcolor: getAvatarColor(name[0]),
                          marginRight: 2,
                        }}
                        title={name}
                      >
                        <Box sx={{ marginTop: "1px", marginLeft: "1px" }}>
                          {name[0].toUpperCase()}
                        </Box>
                      </Avatar>
                    ) : (
                      <Avatar
                        sx={{
                          marginRight: 2,
                        }}
                        title={name}
                      >
                        <AccountCircleIcon
                          fontSize="large"
                          sx={
                            {
                              // marginRight: "10px",
                              // color: "gray",
                            }
                          }
                        />
                      </Avatar>
                    )}

                    {getTimeLine(timelineDetails, index)}
                  </div>
                </div>
              </div>
            );
          }
        })}
      </div>
    </div>
  );
};

export default TimeLineInfo;
